import { render, staticRenderFns } from "./ReferAFriend.vue?vue&type=template&id=089423b8"
import script from "./ReferAFriend.vue?vue&type=script&lang=js"
export * from "./ReferAFriend.vue?vue&type=script&lang=js"
import style0 from "./ReferAFriend.vue?vue&type=style&index=0&id=089423b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports